var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66634 12.1653V9.93331C5.66634 9.07825 6.32954 8.40505 7.31081 8.02138C6.69507 7.79198 6.02867 7.66665 5.33301 7.66665C4.07309 7.66665 2.90922 8.07785 1.96825 8.77331C2.55433 10.4362 3.94149 11.7213 5.66634 12.1653ZM11.5859 9.72391C11.3238 9.36838 10.4469 8.99998 9.33301 8.99998C7.99561 8.99998 6.99967 9.53111 6.99967 9.93331V12.3333C8.95001 12.3333 10.6559 11.2864 11.5859 9.72391ZM5.36634 6.66665C6.19474 6.66665 6.86634 5.99505 6.86634 5.16665C6.86634 4.33822 6.19474 3.66665 5.36634 3.66665C4.53791 3.66665 3.86634 4.33822 3.86634 5.16665C3.86634 5.99505 4.53791 6.66665 5.36634 6.66665ZM9.33301 7.33331C10.0694 7.33331 10.6663 6.73638 10.6663 5.99998C10.6663 5.2636 10.0694 4.66665 9.33301 4.66665C8.59661 4.66665 7.99967 5.2636 7.99967 5.99998C7.99967 6.73638 8.59661 7.33331 9.33301 7.33331ZM6.99967 13.6666C3.31777 13.6666 0.333008 10.6818 0.333008 6.99998C0.333008 3.31808 3.31777 0.333313 6.99967 0.333313C10.6815 0.333313 13.6663 3.31808 13.6663 6.99998C13.6663 10.6818 10.6815 13.6666 6.99967 13.6666Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserGroup);
export default __webpack_public_path__ + "static/media/icon-user-group.11afc16420c9bd99327f4c746e3948d8.svg";
export { ForwardRef as ReactComponent };